/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : edg
 *  date : 08/03/2024
 */

import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationEvent } from './notification-event.enum';
import { Style } from '../../enum/style.enum';
import { Subject } from 'rxjs';

export class Note {
  private notifyObserver: Subject<NotificationEvent> = new Subject();
  public notifyAction$ = this.notifyObserver.asObservable();

  public id = `${new Date().getTime()}`;
  public title: string;
  public icon: string;
  public content: string;
  public info: string;
  public defaultTime = 5000;
  public type: NotificationType;
  public style: Style;
  public time: number;
  public autoClose = false;
  public canClose = false;
  public isOpen = false;

  public progress: number;
  public isLoading = false;
  public index: number;

  constructor(
    title: string,
    icon: string,
    content: string,
    type?: NotificationType,
    info?: string,
    style?: Style,
  ) {
    this.title = title;
    this.icon = icon;
    this.content = content;
    this.info = info;
    this.type = type ? type : NotificationType.alert;
    this.style = style ? style : Style.danger;
  }

  public hide() {
    this.isOpen = false;
  }

  public show() {
    setTimeout(() => {
      this.isOpen = true;
    }, 400);
  }

  public close() {
    this.hide();
    setTimeout(() => {
      this.notifyObserver.next(NotificationEvent.close);
    }, 400);
  }
}
